import { toast } from 'react-hot-toast';
import { useListSearch as useListSearchBase, ListSearchPagination } from '@redpanda/utils';
import i18n from '../i18n';
import { DataTopic } from '../utils/dataEvents';

/** 列表後端搜尋（共用實作 @redpanda/utils useListSearch）：綁定本系統的資料異動主題與錯誤提示 */
export const useListSearch = <T,>(
  topic: DataTopic,
  query: Record<string, unknown> | null,
  fetchPage: (page: number) => Promise<{ data: { data: T[]; pagination: ListSearchPagination } }>
) => useListSearchBase<T>(topic, query, fetchPage, () => toast.error(i18n.t('common.messages.fetchFailed')));
